@use "../../../styles/breakpoint.module.scss" as *;

.root {
    composes: black from "../../../styles/themes.module.scss";
    padding-inline: var(--spacer-margin);
    // --footer-padding-bottom is set by StickyBar when present (StickyBar.module.scss).
    padding-bottom: var(--footer-padding-bottom, var(--spacer-40));
    display: grid;
    grid-template-areas:
        "hr hr hr"
        "logo logo logo"
        "blurb linkgrid linkgrid"
        "legal legal social";
    grid-template-columns: 4fr 5fr 3fr;
    gap: var(--spacer-48) var(--spacer-gutter);

    @media ($below-tablet) {
        grid-template-areas:
            "hr"
            "logo"
            "blurb"
            "linkgrid"
            "social"
            "legal";
        grid-template-columns: auto;
    }

    &::before {
        content: "";
        height: 12px;
        background: var(--red);
        grid-column: 1 / -1;
    }
}

.logo {
    grid-area: logo;
    max-width: 161px;
}

.blurb {
    composes: fontSH24 from "../../../styles/typography.module.scss";

    :has(> &) {
        margin-bottom: var(--spacer-32);
    }
}

.newsletterAndBlurb {
    grid-area: blurb;
}

.newsletterTitle {
    composes: fontB16 from "../../../styles/typography.module.scss";
    margin-bottom: var(--spacer-12);
}

.newsletterBody {
    composes: fontST16 from "../../../styles/typography.module.scss";

    :has(> &) {
        margin-bottom: var(--spacer-16);
    }
}

.newsletterError {
    composes: fontST16 from "../../../styles/typography.module.scss";
    color: var(--color-invalid);
    margin-bottom: var(--spacer-16);
}

.newsletterForm {
    position: relative;

    --label-font-placeholder: var(--font-st-16);
    --label-translate-placeholder: 0 4px;
    --color-invalid: var(--poppy);

    fieldset {
        padding: 0;
        border: none;
    }

    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
        box-shadow: 0 0 0 1000px var(--color-primary) inset;
        -webkit-text-fill-color: var(--color-text);
        caret-color: var(--color-text);
        transition: background-color 5000s ease-in-out 0s;
    }

    input[data-com-onepassword-filled] {
        background-color: var(--color-primary);
        color: var(--color-text);
        transition: background-color 5000s ease-in-out 0s;
    }

    .submit {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);

        svg {
            width: 16px;
            height: 16px;
        }
    }
}

.linkGrid {
    composes: listReset from "../../../styles/utils.module.scss";
    composes: fontST14 from "../../../styles/typography.module.scss";
    grid-area: linkgrid;
    display: grid;
    grid-template-columns: repeat(var(--columns), 1fr);
    gap: var(--spacer-24);

    * {
        display: flex;
        gap: inherit;
        flex-direction: column;
        align-items: start;
    }

    li {
        grid-row: span 1;
        font-weight: 800;
        text-wrap: balance;
    }

    a,
    button {
        font: var(--font-st-16);
        font-weight: 400;

        &:hover {
            text-decoration: underline;
        }
    }

    ul,
    li:has(> ul) {
        grid-column: span 1;
        grid-row: span 3;
    }

    @media ($below-mobile) {
        grid-template-columns: 1fr 1fr;
        gap: var(--spacer-24) var(--spacer-40);

        li:has(> ul) {
            grid-row: span 1;
        }
    }
}

.social {
    grid-area: social;
    display: flex;
    justify-content: flex-end;
    align-self: center;

    @media ($below-tablet) {
        justify-content: flex-start;
    }
}

.legal {
    grid-area: legal;
    display: flex;
    flex-direction: column;
    gap: var(--spacer-8);
}

.legalLinks {
    composes: listReset from "../../../styles/utils.module.scss";
    composes: fontST12 from "../../../styles/typography.module.scss";
    display: flex;
    gap: var(--spacer-8);

    a,
    button {
        &:hover {
            text-decoration: underline;
        }
    }
}

.legalText {
    composes: fontST12 from "../../../styles/typography.module.scss";
}
